import React from 'react';
import block from 'propmods';
import { Button, Tooltip, ButtonTheme } from 'lego-on-react';
import * as keyset from 'i18n/Common';
import i18n from '@yandex-int/i18n';
import { Field } from '../Form/Form';
import { useCopy } from '../../hooks/useCopy';

import './CopyField.scss';

const t = i18n(keyset);

interface Props {
    text: string;
    label: React.ReactNode;
    buttonLabel?: string;
    description?: React.ReactNode;
    caption?: React.ReactNode;
    border?: boolean;
    theme?: ButtonTheme;
}

const b = block('CopyField');

const CopyField: React.SFC<Props> = (props) => {
    const { text, buttonLabel = t('to-copy'), description, label, caption, border = true, theme = 'normal' } = props;

    const { getTooltipProps, onButtonClick, onCodeClick, textRef, buttonRef } = useCopy();

    const tooltipProps = getTooltipProps();

    return (
        <div {...b()}>
            <Field name="code" label={label} caption={caption}>
                <div {...b('code', { border })} ref={textRef} onClick={onCodeClick}>
                    {text}
                </div>
                <Button theme={theme} size="s" onClick={onButtonClick} ref={buttonRef}>
                    {buttonLabel}
                </Button>
                {tooltipProps.visible && (
                    <Tooltip {...tooltipProps} theme="white" autoclosable to="right" size="s">
                        {t('copied')}
                    </Tooltip>
                )}
                {description ? description : null}
            </Field>
        </div>
    );
};

export default CopyField;
